import React from "react";
import { connect } from "react-redux";
import {
  Spin,
  Empty,
  Avatar,
  Flex,
  Badge,
  Tooltip,
  Collapse,
  Tag,
  Select,
} from "antd";
import {
  calculateTimeDifference,
  FormatTimeAgo,
} from "../../helpers/formatTimeAgo";
import { tagsBageStatus, tagsColorBalance } from "../../helpers/tagsBage";
import moment from "moment";
import { withTranslation } from "react-i18next";
import {
  calculateDaysUsed,
  convertMsToMinutes,
  formatPromptPayNumber,
  getNofTelegram,
  // getFormattedTimezone,
} from "../../utils";
import {
  ClockCircleOutlined,
} from "@ant-design/icons";
import { CopyTextToClipboard } from "../../helpers/copy";
import { timeRange } from "../../Data/BankData";
import { getIcon } from "../../helpers/getIcon";

// Component ใหม่สำหรับแสดงรายการธุรกรรมแต่ละรายการ
const TransactionItem = ({ data }) => {
  // ฟังก์ชันสำหรับแปลงรูปแบบวันที่
  const formattedDate = moment(data.transactionDateTime).format(
    "DD/MM/YYYY HH:mm",
  );

  // ตรวจสอบว่าเป็นรายการเงินเข้า (deposit) หรือเงินออก (withdraw)
  const isDeposit = data.deposit !== null;
  const amount = isDeposit ? data.deposit : data.withdraw;
  const amountColor = isDeposit ? "text-success" : "text-danger";
  const amountSign = isDeposit ? "+" : "-";

  return (
    <div style={{ padding: "10px", borderBottom: "1px solid #f0f0f0" }}>
      <Flex justify="space-between" align="center">
        <div>
          <p style={{ margin: 0, fontWeight: "bold" }}>
            {data.descriptionName}
          </p>
          <p style={{ margin: 0, fontSize: "12px", color: "#888" }}>
            {formattedDate}
          </p>
        </div>
        <div style={{ textAlign: "right" }}>
          <p className={amountColor} style={{ margin: 0, fontWeight: "bold" }}>
            {`${amountSign} ${Intl.NumberFormat().format(amount)} ${data.currency
              }`}
          </p>
          <p style={{ margin: 0, fontSize: "12px", color: "#555" }}>
            คงเหลือ: {Intl.NumberFormat().format(data.ledgerBalance)}
          </p>
        </div>
      </Flex>
    </div>
  );
};

class DepositStatusBank extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  mainChildren = (data) => {
    let parsedData = [];
    try {
      // แปลงข้อมูล JSON String ให้เป็น Array
      parsedData = JSON.parse(data);
    } catch (e) {
      console.error("Failed to parse transaction data:", e);
      return <Empty description="ไม่สามารถแสดงรายการธุรกรรมได้" />;
    }
    if (!Array.isArray(parsedData) || parsedData.length === 0) {
      return <Empty description="ไม่มีรายการธุรกรรม" />;
    }
    const sortedData = [...parsedData].sort(
      (a, b) =>
        moment(b.transactionDateTime).valueOf() -
        moment(a.transactionDateTime).valueOf(),
    );

    return (
      <div className="transaction-list">
        {sortedData.map((item, index) => (
          <TransactionItem key={item?.transactionIndex || index} data={item} />
        ))}
      </div>
    );
  };

  /**
   * ฟังก์ชันจัดการข้อมูลบัญชีและแสดงผล
   */
  handleDataAccount = (accDeposit) => {
    const {
      t,
      get_balance_summerys,
      spinnerID,
      loadingBankAccounts,
      setTimeinterval,
      loadingtimeinterval,
      canViewBalance,
      deposit_minlimit,
      tFormat
    } = this.props; // handleReload , loadingBankAccounts
    let activeKey = ["1"];
    const deposit = Array.isArray(accDeposit)
      ? accDeposit.filter(
        (o) => o?.accountType === "deposit" && o?.status_bank === "Active",
      )
      : [];
    let nofFAILED = []; // data สำหรับเก็บรายการที่มีสถานะ FAILED เพื่อจะส่งไปแจ้งเตืน
    deposit.forEach((item) => {
      const isArray = Array.isArray(item?.Botlog_limittimes)
        ? item?.Botlog_limittimes
        : [];
      isArray.forEach((row) => {
        if (row?.bot_status === "FAILED") {
          nofFAILED.push(row);
        }
      });
    });

    getNofTelegram(nofFAILED);

    if (deposit.length === 0) {
      return (
        <div className="card" style={{ padding: "15px", marginBottom: 0 }}>
          <div className="body">
            <Empty description={t("No data")} />
          </div>
        </div>
      );
    }
  
    return deposit.map((item, key) => {
      const isArray = Array.isArray(item?.Botlog_limittimes)
        ? item?.Botlog_limittimes
        : [];

      const items = isArray.map((row, id) => ({
        key: `${id + 1}`,
        className: loadingBankAccounts ? `` : `in-${id}`,
        label: (
          <span
            style={{ color: row?.bot_status === "FAILED" ? "#f55555" : "" }}
          >
            <ClockCircleOutlined />{" "}
            {moment(row?.created_at).format("YYYY-MM-DD HH:mm")}
            <small
              className="d-block"
              style={{
                color: row?.bot_status === "FAILED" ? "#f55555" : "#888",
              }}
            >
              {/* ธุรกรรมฝากเงิน {row?.getupdate_data} รายการ */}
              {row?.bot_status === "FAILED" ? (
                t("Note", { note: t(row?.note) })
              ) : (
                <>
                  {t("Deposit transactions", {
                    transactions: row?.bot_status === "SUCCESS" ? row?.getupdate_data : '-',
                  })}
                </>
              )}
            </small>
            <small
              className="d-block"
              style={{
                color: row?.bot_status === "FAILED" ? "#f55555" : "#888",
              }}
            >
              {/* ธุรกรรมฝากเงิน {row?.getupdate_data} รายการ */}
              {t("durationed", {
                duration: calculateTimeDifference(
                  row?.created_at,
                  row?.finished_at,
                ),
              })}
            </small>
          </span>
        ),
        // children: this.mainChildren(row?.getupdate_data),
        extra: (
          <Tag
            icon={getIcon(row?.bot_status)}
            color={tagsBageStatus(row?.bot_status)}
          >
            {t(row?.bot_status)}
          </Tag>
        ),
        disabled: JSON.parse(row?.old_data)?.length === 0 ? true : false,
        style: { borderBottom: "none" },
        showArrow: false,
      }));

      return (
        <Spin spinning={item?.id === spinnerID}>
          <div
            className="card"
            style={{ padding: "15px", marginBottom: 20 }}
            key={item?.id}
          >
            <div className="body fs-sm-12">
              <div className="row clearfix mb-3">
                <div className="col-lg-6 col-md-12 col-sm-12 mb-3 fs-sm-11">
                  <div className="receipt-left">
                    <Flex
                      gap={5}
                      align="center"
                      direction="horizontal"
                      size={16}
                    >
                      <Avatar size={24} src={item?.bank?.imageUrl} />
                      <h5
                        title={t(item?.bank?.bank_id)}
                        className={ `${item?.bank?.bank_id === "ICBC" && tFormat === "en" ? "fs-12" : "fs-sm-18"}`}
                        style={{ marginBottom: 0, maxWidth: 300 }}
                      >
                        {t(item?.bank?.bank_id)} {" "}
                      </h5>
                    </Flex>
                    <div
                      className={`mt-3 mb-1`}
                      title={item?.accountName}
                      style={{ maxWidth: 300 }}
                    >
                      <b>{t("account name")}</b>
                      <code style={{ color: "rgb(90 90 90)" }}>
                        {" "}
                        : {item?.accountName}
                      </code>
                    </div>
                    <div className="">
                      <b>{t("account number")}</b>
                      <code
                        style={{ cursor: "copy", color: "rgb(90 90 90)" }}
                        onClick={() => CopyTextToClipboard(item?.accountNumber)}
                      >
                        {" "}
                        : {formatPromptPayNumber(item?.accountNumber)}
                      </code>
                    </div>
                    <div className="">
                      <b>{t("Type")}</b>
                      <code style={{ color: "rgb(90 90 90)" }}>
                        {" "}
                        : {item?.accountpay_Type || "-"}
                      </code>
                    </div>
                    <div className="">
                      <b>{t("Min Payin")}</b>
                      <code style={{ color: "rgb(90 90 90)" }}>
                        {" "}
                        : {deposit_minlimit}
                      </code>
                    </div>
                    <div className="">
                      <b>{t("timeinterval")}</b>
                      <code style={{ color: "rgb(90 90 90)" }}>
                        {" "}
                        :{" "}
                        {`${convertMsToMinutes(item?.timeinterval_ms)} ${t("minutes")}`}
                        <Tooltip color={"blue"} title={t("Caution")} className="d-none">
                          <Select
                            size="small"
                            style={{ color: "#888", width: 90 }}
                            onChange={(e) => setTimeinterval(e, item)}
                            variant={"borderless"}
                            loading={loadingtimeinterval === item?.id}
                            disabled={loadingtimeinterval === item?.id}
                            value={`${convertMsToMinutes(item?.timeinterval_ms)} ${t("minutes")}`}
                            options={[
                              {
                                label: <span>{t("Select")}</span>,
                                options: [
                                  { value: "1", label: `1 ${t("minutes")}` },
                                  { value: "1.3", label: `1.3 ${t("minutes")}` },
                                  { value: "2", label: `2 ${t("minutes")}` },
                                  { value: "3", label: `3 ${t("minutes")}` },
                                  { value: "4", label: `4 ${t("minutes")}` },
                                  { value: "5", label: `5 ${t("minutes")}` },
                                ],
                              },
                            ]}
                          />
                        </Tooltip>
                      </code>
                    </div>
                    <div className="">
                      <b>{t("opening hours")}</b>
                      <code style={{ color: "rgb(90 90 90)" }}>
                        {" "}
                        : {timeRange(item?.bank?.bank_id, "Deposit", t) || "-"}
                      </code>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12 fs-sm-11 text-right">
                  <br className="hidden-sm" />
                  <br className="hidden-sm" />
                  <br className="hidden-sm" />
                  <div className="mb-0 ">
                    <div className="h4 fs-sm-16">
                      <span id="balance-payin">
                        {!canViewBalance ? <code className="fs-14 fs-sm-12 " title={t("You do not have permission to view your account balance.")} style={{ color: "#555", cursor: "help" }}>******</code> : (<>
                          {item?.id !== spinnerID ? (
                            <code style={{ color: tagsColorBalance(item?.balance) }}>
                              ฿ {Intl.NumberFormat().format(item?.balance)}
                            </code>
                          ) : (
                            <i className="bx bx-loader-circle bx-spin"></i>
                          )}
                        </>)}

                      </span>{" "}
                      <small >
                        {!canViewBalance ? null : (<>
                          {item?.id === spinnerID ? null : (
                            <>
                              {" "}
                              <i
                                className="bx bx-revision icon-hover"
                                style={{ fontSize: "18px", cursor: "pointer", opacity: 0.5 }}
                                onClick={() => get_balance_summerys(item?.id)}
                              />
                            </>
                          )}
                        </>)}

                      </small>
                    </div>
                  </div>
                  <p className="mb-0">
                    <i
                      className=""
                      style={{ fontSize: 12, opacity: 0.4 }}
                      children={<>{t("ACC_DEP_No", { counter: key + 1 })}</>}
                    />
                  </p>
                  < br />
                  <p className="mb-0 fs-13 fs-sm-11">
                    {t("days used")} : {calculateDaysUsed(item?.created_at)}{" "}
                  </p>
                  {/* <p>เหลือเวลาใช้งาน : {calculateAccountRemainingDays(item)} วัน</p> */}
                  <div className="fs-13 fs-sm-11">
                    <b>{t("updatedAt")} :</b>{" "}
                    <Tooltip
                      placement="top"
                      title={moment(item?.updated_at)
                        .locale("th")
                        .format("YYYY-MM-DD HH:mm:ss")}
                    >
                      <b>{FormatTimeAgo(item?.updated_at)}</b>
                    </Tooltip>
                  </div>
                </div>
              </div>
              <Collapse
                defaultActiveKey={isArray.length <= 0 ? [] : activeKey}
                className="fs-sm-11"
                style={{
                  border: "none",
                  color: "rgb(90 90 90)",
                  fontWeight: "600",
                }}
                items={[
                  {
                    key: "1",
                    label: t("ดึงยอด (10 ครั้งล่าสุด)"),
                    children:
                      isArray.length <= 0 ? (
                        <Empty />
                      ) : (
                        <Collapse
                          expandIconPosition={"end"}
                          items={items}
                          collapsible="disabled"
                          accordion
                          className="scrollbar"
                          style={{
                            border: "none",
                            color: "rgb(90 90 90)",
                            background: "rgba(0, 0, 0, 0)",
                            maxHeight: 400,
                          }}
                        />
                      ),
                    extra: <>{t("status")}</>,
                    showArrow: false,
                  },
                ]}
              />
            </div>
          </div>
        </Spin>
      );
    });
  };

  render() {
    const { activeAccountData, t } = this.props;

    return (
      <Badge.Ribbon
        text={<span style={{ color: "#fff", fontWeight: "500" }}>{t("Deposit")}</span>}
        color="rgb(82, 196, 26)"
      >
        {this.handleDataAccount(activeAccountData, t)}
      </Badge.Ribbon>
    );
  }
}

const mapStateToProps = ({ UIElementsReducer }) => ({});
export default connect(
  mapStateToProps,
  {},
)(withTranslation()(DepositStatusBank));
